import React from "react";
import "./ServicesSection.css";

const services = [
  {
    title: "Branding",
    tone: "gold",
    blurb:
      "Build a polished, consistent brand identity that helps your business stand out and earn trust.",
    href: "/services",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2l7 4v6c0 5-3.5 9-7 10-3.5-1-7-5-7-10V6l7-4zM7 9h10M7 13h6" />
      </svg>
    ),
  },
  {
    title: "Logo Design",
    tone: "blue",
    blurb:
      "Custom logo design that creates a strong first impression and gives your business a memorable identity.",
    href: "/services",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 4h16v4H4zM4 10h10v10H4zM16 10l4 4v6h-4z" />
      </svg>
    ),
  },
  {
    title: "Website Design",
    tone: "violet",
    blurb:
      "Modern, responsive websites designed to look professional and turn visitors into leads.",
    href: "/services",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 4h18v14H3zM7 20h10M9 8l-2 2 2 2M15 12l2-2-2-2" />
      </svg>
    ),
  },
  {
    title: "Social Media Design",
    tone: "coral",
    blurb:
      "Branded social content and graphics that help your business show up consistently online.",
    href: "/services",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 5h18v10H6l-3 4z" />
      </svg>
    ),
  },
  {
    title: "SEO & Digital Marketing",
    tone: "teal",
    blurb:
      "Smart marketing support to improve visibility, drive traffic, and help your business grow online.",
    href: "/services",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2l2 6 6 2-6 2-2 6-2-6-6-2 6-2z" />
      </svg>
    ),
  },
];

function ServicesSection() {
  return (
    <section className="ays">
      <div className="ays__head">
        <span className="ays__kicker">Our Services</span>
        <h2>Creative services designed to help your business grow.</h2>
      </div>

      <div className="ays__grid" role="list">
        {services.map((s) => (
          <article
            key={s.title}
            role="listitem"
            className={`aysCard tone-${s.tone}`}
          >
            <div className="aysCard__icon" aria-hidden="true">
              {s.icon}
            </div>

            <h3 className="aysCard__title">{s.title}</h3>
            <p className="aysCard__blurb">{s.blurb}</p>

            <a className="aysCard__cta" href={s.href}>
              Learn more
              <span className="aysCard__arrow" aria-hidden="true">
                ↗
              </span>
            </a>
          </article>
        ))}
      </div>

      <div className="ays__wave" aria-hidden="true" />
    </section>
  );
}

export default ServicesSection;